import { Area } from 'react-easy-crop';

export const MAX_DIMENSION_PX = 100;

export const createImage = async (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.src = url;
  });

export const getCroppedPicture = async (originalPictureBlobSrc: string, croppedArea: Area): Promise<Blob | null> => {
  const croppedCanvas = document.createElement('canvas');

  const srcImage = await createImage(originalPictureBlobSrc);
  const croppedCtx = croppedCanvas.getContext('2d');
  croppedCanvas.width = MAX_DIMENSION_PX;
  croppedCanvas.height = MAX_DIMENSION_PX;

  if (!croppedCtx) {
    return null;
  }

  croppedCtx.drawImage(
    srcImage,
    croppedArea.x,
    croppedArea.y,
    croppedArea.width,
    croppedArea.height,
    0,
    0,
    MAX_DIMENSION_PX,
    MAX_DIMENSION_PX,
  );

  return new Promise((resolve) => {
    croppedCanvas.toBlob((file) => {
      if (file) {
        resolve(file);
      }
    }, 'image/jpeg');
  });
};
